var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "black",
    viewBox: "0 0 14 15",
    className: "transition-colors duration-300 fill-[#2E2E2E] st-current",
    width: 14,
    height: 14,
    "data-label": "svg.transition-colors",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 1.237H1.75a.583.583 0 0 0-.583.583v10.5a.583.583 0 0 0 .583.583h10.5a.583.583 0 0 0 .584-.583V1.82a.583.583 0 0 0-.584-.583zm-5.833 10.5H2.334V9.403h4.083v2.334zm0-3.5H2.334V5.903h4.083v2.334zm5.25 3.5H7.584V9.403h4.083v2.334zm0-3.5H7.584V5.903h4.083v2.334zm0-3.5H2.334V2.403h9.333v2.334z",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.434876917b85b20fdeb6da9c78ae5b38.svg";
export { ForwardRef as ReactComponent };